module.exports = __webpack_public_path__ + "img/delete.dcd794bd.svg";